const locale = {
	pageTitle: 'ISO 9001 质量管理体系验证 | 擎亿精密有限公司',
	pageDesc:
		'擎亿精密通过 ISO 9001:2015 质量管理体系国际认证，建立标准化生产流程与完整质量追溯机制，每批产品出货前均经三次元 CMM 量测与外观检验，确保符合客户规格与国际质量标准。',
	pageKeywords:
		'ISO 9001, ISO 9001:2015, 质量管理体系, 质量认证, CMM 量测, 精密加工品管, 擎亿精密',
	title: 'ISO 9001 质量管理体系验证',
	subtitle: 'ISO 9001:2015 Quality Management System Certification',
	clickHint: '点击图片可放大查看'
};

export default locale;
